import { jsx as a, jsxs as b, Fragment as g } from "react/jsx-runtime";
import f, { forwardRef as _, useId as y, isValidElement as p, cloneElement as u } from "react";
import { c as n } from "./clsx-OuTLNxxd.js";
import { a as W } from "./Tooltip-B32dr0H7.js";
import './Table.css';const H = "320px", z = "600px", w = "1025px", C = "_tableGroup_10f21_32", S = "_table_10f21_32", B = "_tableLabel_10f21_46", T = "_tableWrapper_10f21_64", N = "_tableCaption_10f21_82", R = "_tableRow_10f21_99", v = "_tableHeader_10f21_103", F = "_tableColumn_10f21_103", D = "_tableBody_10f21_113", G = "_tableCell_10f21_113", I = "_tableFooter_10f21_115", j = "_highlight_10f21_135", k = "_showDividers_10f21_169", L = "_cellWrapper_10f21_205", $ = "_headingText_10f21_132", E = "_columnWrapper_10f21_208", e = {
  mobile: H,
  "mobile-wide": "480px",
  tablet: z,
  "tablet-wide": "800px",
  desktop: w,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  tableGroup: C,
  table: S,
  tableLabel: B,
  tableWrapper: T,
  tableCaption: N,
  tableRow: R,
  tableHeader: v,
  "tableRow-size--s": "_tableRow-size--s_10f21_103",
  tableColumn: F,
  "tableRow-size--m": "_tableRow-size--m_10f21_107",
  tableBody: D,
  tableCell: G,
  tableFooter: I,
  "headingText--mobile": "_headingText--mobile_10f21_132",
  highlight: j,
  showDividers: k,
  "highlight--green": "_highlight--green_10f21_188",
  "highlight--amber": "_highlight--amber_10f21_192",
  "highlight--red": "_highlight--red_10f21_196",
  "mobile-hide": "_mobile-hide_10f21_200",
  cellWrapper: L,
  headingText: $,
  columnWrapper: E
}, K = ({ children: i, className: t, row: l, ...o }) => /* @__PURE__ */ a("thead", { className: n(e.tableHeader, t), style: { "--gridRow": l }, ...o, children: i }), M = ({ children: i, className: t, ...l }) => /* @__PURE__ */ a("tbody", { className: n(e.tableBody, t), ...l, children: i }), O = ({ children: i, className: t, ...l }) => /* @__PURE__ */ a("tfoot", { className: n(e.tableFooter, t), ...l, children: i }), P = ({ children: i, className: t, size: l = "m", ...o }) => /* @__PURE__ */ a("tr", { className: n(e.tableRow, e[`tableRow-size--${l}`], t), ...o, children: i }), Q = ({ children: i, className: t, ...l }) => /* @__PURE__ */ a("caption", { className: n(e.tableCaption, t), ...l, children: i }), U = ({
  alignItems: i = "center",
  children: t,
  className: l,
  highlight: o,
  justifyContent: c = "flex-start",
  mobileText: s,
  mobileView: x,
  showDividers: h,
  toolTipSide: d,
  tooltipText: r,
  ...m
}) => /* @__PURE__ */ a(
  "th",
  {
    className: n(
      e.tableColumn,
      e[`mobile-${x}`],
      {
        [e.highlight]: o,
        [e.showDividers]: h
      },
      l
    ),
    ...m,
    children: /* @__PURE__ */ b(
      "div",
      {
        className: e.columnWrapper,
        style: {
          "--alignItems": i,
          "--justifyContent": c
        },
        children: [
          s ? /* @__PURE__ */ b(g, { children: [
            /* @__PURE__ */ a("span", { className: e["headingText--mobile"], children: s }),
            /* @__PURE__ */ a("span", { className: e.headingText, children: t })
          ] }) : /* @__PURE__ */ a(g, { children: t }),
          r && /* @__PURE__ */ a(W, { side: d, children: r })
        ]
      }
    )
  }
), X = ({
  alignItems: i = "center",
  children: t,
  className: l,
  highlight: o,
  justifyContent: c = "flex-start",
  showDividers: s,
  style: x,
  ...h
}) => /* @__PURE__ */ a(
  "td",
  {
    className: n(
      e.tableCell,
      {
        [e.highlight]: o,
        [e[`highlight--${o}`]]: o,
        [e.showDividers]: s
      },
      l
    ),
    style: {
      ...x,
      "--alignItems": c,
      "--justifyContent": i
    },
    ...h,
    children: /* @__PURE__ */ a("div", { className: e.cellWrapper, children: t })
  }
), Y = _(({ children: i, className: t, ...l }, o) => /* @__PURE__ */ a("div", { className: e.tableWrapper, "data-cxy-name": "table", children: /* @__PURE__ */ a("table", { className: n(e.table, t), ref: o, ...l, children: i }) })), Z = ({ children: i, className: t, label: l }) => {
  const o = y(), c = f.Children.map(
    i,
    (s) => p(s) ? u(s, {
      "aria-labelledby": o
    }) : s
  );
  return /* @__PURE__ */ b("div", { className: n(e.tableGroup, t), children: [
    l && /* @__PURE__ */ a("h3", { className: e.tableLabel, id: o, children: l }),
    c
  ] });
};
export {
  Y as T,
  M as a,
  Q as b,
  X as c,
  U as d,
  O as e,
  Z as f,
  K as g,
  P as h
};
